module.exports = "/assets/close-17b911829c77b3e2302c4f0d271af70b.svg";